// extracted by mini-css-extract-plugin
module.exports = {"mobileAppWrapper":"mobileApp_mobileAppWrapper__uyeXG","mobileAppContainer":"mobileApp_mobileAppContainer__OwFL8"};